import * as React from "react";
import Modal from "@mui/material/Modal";
import * as style from "./Styled";
import "./style.css";

import PhotoCardComponent from "./PhotoCardComponent";
import TitleCardComponent from "./TitleCardComponent";
import { useDispatch, useSelector } from "react-redux";
import { createBoard } from "../../../Services/boardsService";
import LoadingScreen from "../../LoadingScreen";

export default function CreateBoard(props) {
  const dispatch = useDispatch();
  const creating = useSelector((state) => state.boards.creating);
  const { backgroundImages, smallPostfix } = useSelector(
    (state) => state.boards
  );

  const [open, setOpen] = React.useState(true);
  const [background, setBackground] = React.useState(
    backgroundImages[0] + smallPostfix
  );

  // ✅ Use useRef to persist data
  const newBoardRef = React.useRef({});

  const handleClick = async () => {
    const boardToCreate = {
      ...newBoardRef.current,
      backgroundImage: background, // You might want to save this too
    };

    if (!boardToCreate.title || boardToCreate.title.trim() === "") {
      alert("Please provide a board title.");
      return;
    }

    await createBoard(boardToCreate, dispatch);
    props.callback();
    setBackground(backgroundImages[0] + smallPostfix);
  };

  const handleSelect = (link) => {
    setBackground(link);
  };

  const handleClose = () => {
    setOpen(false);
    props.callback();
  };

  const handleUpdate = (updatedBoard) => {
    newBoardRef.current = { ...updatedBoard };
  };

  return (
    <div style={{ position: "relative" }}>
      {creating && <LoadingScreen />}
      <Modal open={open} onClose={handleClose} disableEnforceFocus>
        <style.Container>
          <style.Wrapper
            style={{
              position: "relative",
              backgroundImage: `url(${background})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              borderRadius: "10px",
              overflow: "hidden",
            }}
          >
            {/* Black overlay */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                borderRadius: "10px",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 1,
              }}
            />

            {/* Content overlay */}
            <div
              className="content-overlay"
              style={{
                position: "relative",
                zIndex: 2,
                width: "95%",
              }}
            >
              <TitleCardComponent
                link={background}
                updateback={handleUpdate}
                callback={handleClose}
              />
              <style.PhotosCard>
                {backgroundImages.map((item, index) => (
                  <PhotoCardComponent
                    key={index}
                    selectedLink={background}
                    link={item + smallPostfix}
                    callback={handleSelect}
                  />
                ))}
              </style.PhotosCard>
              <div className="create-board-button">
                <style.CreateButton onClick={handleClick}>
                  Create Board
                </style.CreateButton>
              </div>
            </div>
          </style.Wrapper>
        </style.Container>
      </Modal>
    </div>
  );
}
